<template>
  <div>
    <v-row class="text-center" justify="space-between">
      <v-col cols="auto">
        <v-checkbox v-model="item.isChecked" class="ma-0 pa-0"></v-checkbox
      ></v-col>
      <v-col cols="1">{{ item.projectcode }}</v-col>
      <v-col cols="2">{{ item.contractno }}</v-col>
      <v-col cols="2">
        <v-btn small text color="primary" @click="sample">查看</v-btn>
      </v-col>
      <v-col cols="2">{{ item.deadline }}</v-col>
      <v-col cols="1">{{ zt }}</v-col>
      <v-col cols="1">
        <v-btn
          small
          text
          color="primary"
          @click="retrieve"
          v-if="showRetrieveStatus.includes(item.status)"
          >申请回收</v-btn
        >
        <v-btn
          small
          text
          color="primary"
          @click="destroy"
          v-if="showDestroyStatus.includes(item.status)"
          >申请销毁</v-btn
        >
        <v-btn
          small
          text
          color="primary"
          @click="logistics"
          v-if="showLogisticsStatus.includes(item.status)"
          >物流信息</v-btn
        >
        <v-btn
          small
          text
          color="primary"
          @click="process"
          v-if="showProcessStatus.includes(item.status)"
          >流程</v-btn
        >
      </v-col>
    </v-row>
    <!-- 样本列表 -->
    <remain-sample v-model="showSample" :item="item" />
    <!-- 申请回收 -->
    <retrieve v-model="showRetrieve" :item="item" :sendParams="sendParams" v-on="$listeners" />
    <!-- 申请销毁 -->
    <destroy v-model="showDestroy" :item="item" v-on="$listeners" />
    <!-- 流程 -->
    <process v-model="showProcess" :item="item" />
  </div>
</template>
<script>
import { asg } from "@/plugins/chart";
import remainSample from "./remainSample.vue";
import retrieve from "./retrieve.vue";
import destroy from "./destroy.vue";
import process from "./process.vue";

export default {
  components: {
    remainSample,
    retrieve,
    destroy,
    process,
  },
  props: ["item", "sendParams"],
  data() {
    return {
      showSample: false,
      showRetrieve: false,
      showRetrieveStatus: ["0"], //可以展示申请回收的状态
      showDestroy: false,
      showDestroyStatus: ["0"], //可以展示申请销毁的状态
      showLogisticsStatus: ["1", "2"], //可以展示物流信息的状态
      showProcess: false,
      showProcessStatus: ["1", "2", "3", "5"], //可以展示流程的状态
    };
    // wait: "0", //待处理
    // recovering: "1", //回收中
    // recovered: "2", //回收完成
    // destroyed: "3", //销毁完成
    // destroy: "4", //到期销毁
    // destroying: "5", //销毁中
  },
  computed: {
    zt() {
      let ztName = undefined;
      asg.sampleStatus.forEach((item) => {
        if (item.value == this.item.status) {
          ztName = item.name;
        }
      });
      return ztName;
    },
  },
  methods: {
    retrieve() {
      this.showRetrieve = true;
    },
    destroy() {
      this.showDestroy = true;
    },
    logistics() {
      if (this.item.postno) {
        const url = `https://www.kuaidi100.com/chaxun?com=shunfeng&nu=${this.item.postno}`;
        window.open(url, "_blank");
      } else {
        this.$message.warn("暂无物流信息，请稍后再试");
      }
    },
    process() {
      this.showProcess = true;
    },
    sample() {
      this.showSample = true;
    },
  },
};
</script>
